{
  "common": {
    "save": "Uložit",
    "cancel": "Zrušit",
    "delete": "Smazat",
    "edit": "Upravit",
    "create": "Vytvořit",
    "search": "Hledat",
    "loading": "Načítám...",
    "back": "Zpět",
    "next": "Další",
    "yes": "Ano",
    "no": "Ne",
    "language": "Jazyk",
    "settings": "Nastavení",
    "logout": "Odhlásit se",
    "today": "Dnes",
    "yesterday": "Včera",
    "thisMonth": "Tento měsíc",
    "lastMonth": "Minulý měsíc",
    "load": "Načíst",
    "all": "Vše",
    "active": "Aktivní",
    "inactive": "Neaktivní",
    "saved": "Uloženo",
    "error": "Chyba",
    "noData": "Žádná data"
  },
  "sidebar": {
    "dashboard": "Přehled",
    "newOrder": "Nová objednávka",
    "preorders": "Předobjednávky",
    "kitchen": "Kuchyně",
    "dispatch": "Rozvoz - nástěnka",
    "restaurant": "Restaurace",
    "tableMap": "Mapování stolů",
    "categories": "Kategorie",
    "products": "Produkty",
    "analytics": "Analytika",
    "statistics": "Statistiky",
    "summaries": "Souhrny",
    "marketing": "Marketing",
    "employees": "Zaměstnanci",
    "attendance": "Docházka",
    "systemSettings": "Systémová nastavení"
  },
  "profile": {
    "title": "Můj profil",
    "tabs": {
      "personal": "Osobní údaje",
      "security": "Zabezpečení",
      "performance": "Můj výkon",
      "attendance": "Moje docházka"
    },
    "firstName": "Jméno",
    "lastName": "Příjmení",
    "save": "Uložit změny"
  },
  "attendance": {
    "arrive": "Příchod",
    "leave": "Odchod",
    "notInShift": "Mimo směnu",
    "inShift": "Ve směně",
    "shiftClosed": "Směna uzavřená"
  }
}
